/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { QuotingActivationStrategyType } from "./QuotingActivationStrategyType";
import {
  QuotingActivationStrategyTypeFromJSON,
  QuotingActivationStrategyTypeFromJSONTyped,
  QuotingActivationStrategyTypeToJSON,
  QuotingActivationStrategyTypeToJSONTyped,
} from "./QuotingActivationStrategyType";

/**
 *
 * @export
 * @interface CarrierServiceType
 */
export interface CarrierServiceType {
  /**
   *
   * @type {string}
   * @memberof CarrierServiceType
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof CarrierServiceType
   */
  carrierDisplayName: string;
  /**
   *
   * @type {string}
   * @memberof CarrierServiceType
   */
  serviceIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof CarrierServiceType
   */
  serviceDisplayName: string;
  /**
   *
   * @type {QuotingActivationStrategyType}
   * @memberof CarrierServiceType
   */
  quotingActivationStrategyType: QuotingActivationStrategyType;
}

/**
 * Check if a given object implements the CarrierServiceType interface.
 */
export function instanceOfCarrierServiceType(
  value: object,
): value is CarrierServiceType {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (
    !("carrierDisplayName" in value) ||
    value["carrierDisplayName"] === undefined
  )
    return false;
  if (
    !("serviceIdentifier" in value) ||
    value["serviceIdentifier"] === undefined
  )
    return false;
  if (
    !("serviceDisplayName" in value) ||
    value["serviceDisplayName"] === undefined
  )
    return false;
  if (
    !("quotingActivationStrategyType" in value) ||
    value["quotingActivationStrategyType"] === undefined
  )
    return false;
  return true;
}

export function CarrierServiceTypeFromJSON(json: any): CarrierServiceType {
  return CarrierServiceTypeFromJSONTyped(json, false);
}

export function CarrierServiceTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierServiceType {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier: json["carrierIdentifier"],
    carrierDisplayName: json["carrierDisplayName"],
    serviceIdentifier: json["serviceIdentifier"],
    serviceDisplayName: json["serviceDisplayName"],
    quotingActivationStrategyType: QuotingActivationStrategyTypeFromJSON(
      json["quotingActivationStrategyType"],
    ),
  };
}

export function CarrierServiceTypeToJSON(json: any): CarrierServiceType {
  return CarrierServiceTypeToJSONTyped(json, false);
}

export function CarrierServiceTypeToJSONTyped(
  value?: CarrierServiceType | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    carrierDisplayName: value["carrierDisplayName"],
    serviceIdentifier: value["serviceIdentifier"],
    serviceDisplayName: value["serviceDisplayName"],
    quotingActivationStrategyType: QuotingActivationStrategyTypeToJSON(
      value["quotingActivationStrategyType"],
    ),
  };
}
